import { CacheKey } from "@/modules/cache/constants";
import { GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";

export type ElectronAppInfo = {
  electronSystemArchitecture: string;
  electronAppVersion: string;
  electronRuntimeVersion: string;
};

export const setMetricsElectronAppInfo = async ({
  electronAppInfo,
}: {
  electronAppInfo: ElectronAppInfo;
}) => {
  await GLOBAL_CACHE_INSTANCE.set(CacheKey.MetricsElectronAppInfo, electronAppInfo);
};

export const getMetricsElectronAppInfo = async (): Promise<{
  electronAppInfo: ElectronAppInfo | null;
}> => {
  const cachedData = await GLOBAL_CACHE_INSTANCE.get(CacheKey.MetricsElectronAppInfo, {
    keepInTabMemory: true,
  });

  if (cachedData) {
    return { electronAppInfo: cachedData };
  }

  return { electronAppInfo: null };
};

export const clearMetricsElectronAppInfo = async () => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.MetricsElectronAppInfo);
};
